const MdsRoutable = {
    props: {
        append: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description:
                    'Setting `append` prop always appends the relative path to the current path. You can find more information about the `append` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
        exact: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description:
                    'Setting `exact` prop will change the `active-class` matching behavior from using an inclusive match to an exact match. You can find more information about the `exact` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
        exactPath: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description:
                    'Setting `exact-path` will exactly match the link, ignoring the query and the hash sections. You can find more information about the exact-path prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
        linkTag: {
            type: String,
            default: 'router-link',
            validator(value) {
                return ['router-link', 'nuxt-link'].indexOf(value) !== -1;
            },
            docs: {
                validation: 'One of: `router-link`, `nuxt-link`.',
                description:
                    'Configures if `nuxt-link` or `router-link` should be used. You can find more information about the `tag` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
        noPrefetch: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description: 'Disables the `prefetch` option on a link.',
                support: ['routing'],
            },
        },

        prefetch: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description:
                    'Configures the `prefetch` value on a link by overriding the default value of router.prefetchLinks configured in the nuxt.config.js configuration file.',
                support: ['routing'],
            },
        },
        replace: {
            type: Boolean,
            default: false,
            docs: {
                validation: '—',
                description:
                    'Setting `replace` prop will call `router.replace()` instead of `router.push()` when clicked, so the navigation will not leave a history record. You can find more information about the `replace` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
        to: {
            type: [String, Object],
            docs: {
                validation: '—',
                description:
                    'Determines if a component is used for routing and denotes the target route of the link. You can find more information about the `to` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
                support: ['routing'],
            },
        },
    },
    computed: {
        isRoutable() {
            return this.to !== null && this.to !== undefined;
        },
        routingProps() {
            return this.isRoutable
                ? {
                      append: this.append,
                      exact: this.exact,
                      exactPath: this.exactPath,
                      replace: this.replace,
                      to: this.to,
                      prefetch: this.prefetch,
                      noPrefetch: this.noPrefetch,
                  }
                : null;
        },
    },
};

export default MdsRoutable;
